/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackagePriorityDtoPage } from '../../models/work-package-priority-dto-page';

export interface ListWorkPackagePriorities$Params {
  query?: string;
  tenantId?: string | null;
  isActive?: boolean | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'isDefault' | '-isDefault' | 'isActive' | '-isActive' | 'position' | '-position' | 'icon' | '-icon' | 'color' | '-color' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listWorkPackagePriorities(http: HttpClient, rootUrl: string, params?: ListWorkPackagePriorities$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackagePriorities.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('tenantId', params.tenantId, {});
    rb.query('isActive', params.isActive, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackagePriorityDtoPage>;
    })
  );
}

listWorkPackagePriorities.PATH = '/v0/workPackagePriorities';
